import React from 'react';
import './Tentang.css';
import tentang from '../images/tentang.jpg';


class Tentang extends React.Component {
   
    render () {
      return (
        <div className=" tentang jumbotron jumbotron-fluid">
            <div className="container">
                <h1>Tentang Kami</h1>
                <div className="row">
                    <div className="col-lg-6 col-8 mx-auto">
                        <img className="img-fluid rounded " src={tentang} alt="" />
                    </div>
                    <div className="col-lg-6 col-12 mx-auto ">
                        <p>
                            LadangShop merupakan suatu aplikasi yang dikhususkan untuk membeli SEMBAKO dari hasil ladang, ternak dan UMKM.
                            Bahan-bahan pokok, sayuran, daging, dan bumbu lainnya yang biasa dibeli dipasar, dapat dipesan dengan mudah via aplikasi ini.
                            Dijamin Halal dan Higienis. Aplikasi ini mempermudah pembeli untuk tetap sehat #dirumahAja.
                            {/* <br />
                            <br />
                            <i className="fa fa-check-square-o" aria-hidden="true"></i> Digitalisasi proses jual-beli UMKM
                            <br />
                            <i className="fa fa-check-square-o" aria-hidden="true"></i> Setiap transaksi tercatat di Ladang Amal Admin dengan Data Visualization yang menarik
                            <br />
                            <i className="fa fa-check-square-o" aria-hidden="true"></i> Simple dan Powerful
                            <br />
                            <i className="fa fa-check-square-o" aria-hidden="true"></i> Meningkatkan jangkauan wilayah penjualan 
                            <br /><br />
                            Dampak positif yang diharapkan dari aplikasi ini adalah
                            Meningkatnya transaksi jual beli yang menjadi salah satu indikator meningkatnya Ekonomi di Indonesia,
                            lalu pembeli akan tetap dirumah karena pembeliannya online, namun tetap bisa bersosialisasi via daring,
                            dan meningkatnya aktivitas masyarakat dirumah karena bisa bercocok tanam yang nantinya hasilnya bisa dijual lewat aplikasi ini. */}
                            
                        </p>
                        <p className="text-center">
                            <span className="text-center">~Kami siap mengantar belanjaan kerumah Anda~</span>
                        </p>
                    </div>
                </div>
            </div>
            
        </div>
      );
    }
  }


export default Tentang;
